





























import Vue from 'vue';

export default Vue.extend({
  name: 'G_080_KojoDekidakaEntry_ChildActionsBtn',
  props: {
    info: {
      type: Boolean,
      default: true,
    },
    edit: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
});
